import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// jQuery
import jQuery from 'jquery'
window.jQuery = jQuery
window.$ = jQuery

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css'

// Owl Carousel
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel'

// 全局样式
import './assets/css/style-starter.css'

// 处理未捕获 Promise 拒绝
window.addEventListener('unhandledrejection', event => {
  console.warn('未捕获的 Promise 拒绝：', event.reason)
  event.preventDefault()
})

// 注册 ElementUI
Vue.use(ElementUI)

// ✅ 注册全局 mixin（方法）
Vue.mixin({
  methods: {
    $formatTextWithLineBreaks(str) {
      if (!str) return '';
      return str.replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;')
          .replace(/\n/g, '<br />');
    }
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
